import React from 'react';
import { getInitials, stringToColor } from './avatarUtils';
import './Avatar.scss';

export interface AvatarProps {
  /** Nome para gerar iniciais e cor */
  name: string;
  /** Tamanho do avatar */
  size?: 'sm' | 'md' | 'lg';
  /** Exibir nome ao lado do avatar */
  showName?: boolean;
  /** Classes CSS adicionais */
  className?: string;
}

/**
 * Componente Avatar com iniciais
 * Gera avatar colorido baseado no nome de forma consistente
 */
export function Avatar({ name, size = 'md', showName = false, className = '' }: AvatarProps) {
  const initials = getInitials(name);
  const bgColor = stringToColor(name);

  const avatarElement = (
    <span
      className={`avatar avatar-${size} ${className}`}
      style={{ backgroundColor: bgColor }}
      title={name}
    >
      {initials}
    </span>
  );

  if (showName) {
    return (
      <span className="avatar-with-name">
        {avatarElement}
        <span className="avatar-name">{name}</span>
      </span>
    );
  }

  return avatarElement;
}

export default Avatar;
